/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css, FlattenSimpleInterpolation } from 'styled-components';

import Colors from '@userzoom-themes/peach/constants/colors';
import { UiBreakpoint } from '../utils/constants';

const rootStyles = (): FlattenSimpleInterpolation => css`
  html,
  body {
    margin: 0;
    padding: 0;
    background-color: ${Colors.grey100}; // JS variable for IE11

    @media (max-width: ${UiBreakpoint}px) {
      background-color: ${Colors.white};
    }
  }
  body {
    -webkit-overflow-scrolling: touch;
  }

  * {
    box-sizing: border-box;
  }


  .link-text {
    display: inline-flex;
    color: ${Colors.action500};
    cursor: pointer;
    outline: none;
    &:hover {
      color: ${Colors.action600};
      text-decoration: underline;
    }
  }

  .legal-dialog {
    .gz-dialog__content {
      overflow-y: auto;
      min-width: 616px;
      max-width: 1024px;
      min-height: 400px;
      max-height: calc(90vh - 102px);
      word-break: break-word;
      -webkit-overflow-scrolling: touch;
      padding: 20px 12px 32px 20px;
    }

    .gz-dialog__header {
      padding-right: 0;
    }

    h1, h2, h3, h4, h5, h6 {
      font-family: var(--font-bold);
    }

    strong {
      font-family: var(--font-semibold);
    }

    * {
      text-align: left;
    }

    a {
      color: ${Colors.action500};
      cursor: pointer;
      outline: none;
      &:hover {
        color: ${Colors.action600};
        text-decoration: underline;
      }
    }
  }


  @media (max-width: ${UiBreakpoint}px) {
    .legal-dialog {

      .gz-dialog__content {
        min-width: 90%;
        max-width: 90%;
        max-height: 95vh;
      }

      h1 {
        font-size: 28px;
      }

      h2 {
        font-size: 24px;
      }
    }
  }
`;

export default rootStyles;
